interface IWujieProps {
  /**是否显示侧边栏 */
  sidebar: boolean
  /**是否显示状态栏 */
  statusbar: boolean
  /**是否显示公告栏 */
  noticebar: boolean
}
interface IWujie {
  /**是否被作为子应用使用 */
  __POWERED_BY_WUJIE__?: boolean
  /**无界的实例（所有方法都在上面） */
  wujie: any
  /**无界传递过来的 prop */
  props: IWujieProps
}
const wujie = window?.$wujie || {}
const props = (window?.$wujie?.props || {}) as IWujieProps
const __POWERED_BY_WUJIE__ = window.__POWERED_BY_WUJIE__

export const useWujie = (): IWujie => {
  return {
    __POWERED_BY_WUJIE__,
    wujie,
    props,
  }
}
